import { PropsOf } from '@emotion/react';
import NextLink from 'next/link';
import { forwardRef } from 'react';

export const Link = forwardRef<HTMLAnchorElement, PropsOf<typeof NextLink>>((props, ref) => (
    <NextLink
        {...props}
        locale={false}
        ref={ref}
    />
));
